import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Pagination from '../components/Pagination';
import '../styles/TransactionPage.css';

const formatStatus = (status) => {
  if (!status) return 'Unknown';
  return status.toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const TransactionPage = () => {
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get( `${API_BASE_URL}/orders/admin`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (Array.isArray(response.data)) {
          setOrders(response.data);
          setFilteredOrders(response.data); // Initialize filtered orders
          setCurrentPage(1);
        } else {
          console.error('Fetched data is not an array:', response.data);
        }

        setLoading(false);
      } catch (error) {
        console.error('Error fetching orders:', error);
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

useEffect(() => {
  const results = orders.filter(order => {
    const searchLower = searchTerm.toLowerCase();
    return (
      order.id.toString().includes(searchLower) ||
      (order.user?.firstName && order.user?.lastName &&
        `${order.user.firstName} ${order.user.lastName}`.toLowerCase().includes(searchLower)) ||
      (order.items && order.items.some(item =>
        item.productName.toLowerCase().includes(searchLower)))
    );
  });

  setFilteredOrders(results);
  setCurrentPage(1);
}, [searchTerm, orders]);


  const handleStatusChange = async (orderId, newStatus) => {
    try {
      const token = localStorage.getItem('token');
      const order = orders.find(o => o.id === orderId);

      await axios.put(
         `${API_BASE_URL}/orders/admin/${orderId}`,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      const [ordersRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/orders/admin`, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);

      setOrders(ordersRes.data);
      setCurrentPage(1);

    } catch (error) {
      console.error('Error updating status:', error);
      alert(`Update failed: ${error.response?.data?.message || error.message}`);
    }
  };

  const indexOfLastOrder = currentPage * itemsPerPage;
  const indexOfFirstOrder = indexOfLastOrder - itemsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  if (loading) return <div>Loading orders...</div>;

  return (
    <div className="transaction-page">
      <h1>Transakcije</h1>

      {/* Search Bar */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search orders by ID, customer, or product..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="orders-section">
        <h2>Sve transakcije</h2>
        <div className="orders-table">
          <table>
            <thead>
              <tr>
                <th>ID Narudžbine</th>
                <th>Kupac</th>
                <th>E-mail</th>
                <th>Proizvodi</th>
                <th>Ukupno</th>
                <th>Status</th>
                <th>Datum</th>
                <th>Ažuriraj Status</th>
              </tr>
            </thead>
            <tbody>
              {currentOrders.length > 0 ? (
                currentOrders.map(order => (
                  <tr key={order.id}>
                    <td>#{order.id}</td>
                    <td>
                      {`${order.user?.firstName || order.guestFirstName || 'N/A'} ${
                        order.user?.lastName || order.guestLastName || ''
                      }`.trim()}
                    </td>
                          <td>
                            {order.user?.email || order.guestEmail || 'N/A'}
                          </td>
                    <td>
                      <ul>
                        {order.items && order.items.length > 0
                          ? order.items.map((item, index) => (
                              <li key={index}>
                                {item.productName} (x{item.quantity})
                              </li>
                            ))
                          : <li>No items</li>
                        }
                      </ul>
                    </td>
                    <td>${order.totalPrice ? order.totalPrice.toFixed(2) : 'N/A'}</td>
                    <td>
                      <span className={`status-badge ${order.status ? order.status.toLowerCase() : 'unknown'}`}>
                        {formatStatus(order.status)}
                      </span>
                    </td>
                    <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                    <td>
                    <select
                      value={order.status || ''}
                      onChange={(e) => handleStatusChange(order.id, e.target.value)}
                    >
                      <option value="PENDING">Na čekanju</option>
                      <option value="PROCESSING">U obradi</option>
                      <option value="SHIPPED">Poslato</option>
                      <option value="DELIVERED">Dostavljeno</option> {/* This should trigger stats */}
                      <option value="CANCELLED">Otkazano</option>
                    </select>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="no-orders">
                    No matching orders found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(filteredOrders.length / itemsPerPage)}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default TransactionPage;